var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_125_1318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_125_1318",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_125_1318",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_125_1318",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEXElEQVR4nO2aTYgcVRDHOyZEIWaqZjdxumoWo5CLOQQkySEnvUQTMSdvKh486s2LB4UFEZOpms0H5JBAiILJJZKDnsxFT2JILvGgBw0oeBAiCBHJJqKO9GbE7Gb79evu1x8zU38oWJju9/Hr6ur3/vuiyGQymUwmk8lkMplMJpPJZDKZTCaTyRRQx3cACsFXyjiyQBeDa0N6dFsp2NrrbVHGywYa14UshF8O5ue3BsnsxV3RZiH8xGDjGsjw2eKO6JHcQEdRtCHtt4tRtFEJPzTY+B/kjxajaFMRlpEyfJx1sxAOZx42wanFKHrIlZTCeNYB2u91UIK3ZxW2MB71LbNO0L4FXhnfUMa/ZwjwP8LwVp6FQyZo3yWLUPdlIfxzBiD/NWB43cXiyOPQXbsU9gU9EoZvlxbm+q4OBowvCsHtqYVMeEdieMmZcNu3x0Jwfe293qDH8ePSQmenE3aMzwjDrenLZPhjSJ0Drrkf6cETQvjDevfnBT1Shl+kj7tdHQ4J9gjjr03D0VBB+Jtwd79rzkfjuaeU4Oe0NgqADtOxTkxkJ9Yg7uzNSqxioMevklDnuaxXSQm/bx4WFo3MUql9eNanVBYGPc7su1kfhxOPbemt93HQlofPx18ZDyvBsk975UB7LncmzfkTxqtZy9kh4St5lrOlQedZwAvj501DzJyLxwZNGN/Mu0ELArrIllRbGFVaDkFB5zFZtAVgV0e1Jlp40DUMWkNHDclREejJcf6kpnJXGei2O39SwIFrLei2On9S0IFrO+ikZn/XFudPPB04JfgmZL81gW6H8yclHbhJAd2s80fNGmE1g25qwmEcuIkCLYR3NO4eck16pf8ePKmENwI82BtJW5n9xd1DK2ObCtCEdxPHK/JUWefPx4G7X0PqPO/rxrUXdE7IZZ0/HweuTtipHbYBcmHnj/CLMmfgqoCd2lmdNXnQ774gjO+4rjm5M3pYGC95ZPKl5FpXW8r4rsTdg3XW7EpBe0OmexMSwmNZZ/6E8Ywjk08n1zjNLIYT966F5TphVwY6L2T9/75zLljjsR0eexA3x3E52Vm67kncxOQw4uoHUx/sakB71GSJuwfT6qAQfFroCGwRB85jrCFqdmrjTUHWQB+0XA5cDbDTB1hjudDU9uDrxEUrCnlpoTMnhFf8EgSWs8ZepoyEAx0qk3kNbIafNO7sywt5yPB07p1lhZkdBHToTNYHM/u2EryXZGgW4A9467wSvF/4Na8os0uDrhqyrs7uW8JwXmJ8NTGJVk5uJpH83cfXlOGCMvxetp8qYJcDXVG50DZE4DJSHPQ0Q+bwsIuBngXIHBZ2ftA1LfC1TRFgzvlAzyJkDjN3f9CzDJnLM/ADbZBHZVlkgzbIoxCZ7QZtkEehykg6aIM8Clmz00FX6GTpNIXndt31e+ZTanyS3JIo+c9ng8wNwbZMxuphG2RsroyYTCaTyWQymUwmk8lkMplMJpPJZDJFs65/AQz4nQZdDZL1AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/Letter.a7e7aae844fd6a2dd46b39c53c856c6f.svg";
export { ForwardRef as ReactComponent };